module.exports = __webpack_public_path__ + "static/img/10.ee5fde9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/10.png
// module id = Jg9x
// module chunks = 0